<script>
    import R, {LOADER} from "../lib/requests";
    import {clickOutside} from '../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';

    export let value;
    export let clientId = null;
    export let right = false;

    let list = [];
    let listIndex = -1;
    let showDropdown = false;
    let totalSamples = null;

    const dispatch = createEventDispatcher();

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeDropdown();
        }
    }

    const onKeyDown = (event) => {
        if (event.key === 'Backspace' || event.key === 'Delete') {
            totalSamples = null;
        }

        if (showDropdown) {
            if (event.key === 'Enter') {
                if (listIndex > -1) {
                    onSelect(list[listIndex]);
                } else {
                    closeDropdown();
                }
            } else if (event.key === 'ArrowDown') {
                event.preventDefault();
                listIndex++;
                if (listIndex > list.length - 1) {
                    listIndex = 0;
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                listIndex--;
                if (listIndex < 0) {
                    listIndex = list.length - 1;
                }
            } else {
                closeDropdown();
            }
        } else {
            if (event.key === 'Enter') {
                load();
            }
        }
    }

    const onChange = (event) => {
        totalSamples = null;
        dispatch("change", value);
    }

    const load = () => {
        const onSuccess = result => {
            list = result;
            openDropdown();
        }

        const onFailure = err => {
        };

        let data = {
            client_id: clientId,
            type: value
        }

        R.handle(R.sample.types, data, onSuccess, onFailure, LOADER.NONE);
    }

    const openDropdown = () => {
        if (showDropdown) {
            return;
        }

        showDropdown = true;
        document.addEventListener('keydown', handleEscapeKey);
    }

    const closeDropdown = () => {
        if (!showDropdown) {
            return;
        }

        list = [];
        listIndex = -1;
        showDropdown = false;
        document.removeEventListener('keydown', handleEscapeKey);
    }

    const onSelect = (item) => {
        value = item.type;
        totalSamples = item.total;
        closeDropdown();
        dispatch("change", value);
        // dispatch("select", item);
    }

    $: if (!value) totalSamples = null;
</script>

<div class="dropdown-container">
    <div class="input-group">
        <input type="text" class="form-control" bind:value="{ value }"
               on:keydown={ onKeyDown }
               on:change={ onChange }>
        {#if totalSamples}
            <span class="input-group-text">{ totalSamples }</span>
        {/if}
    </div>
    {#if showDropdown}
        <div class="dropdown" class:right={ right } use:clickOutside on:click_outside="{ closeDropdown }">
            {#each list as item, index}
                <li class="dropdown-item pointer py-1 d-flex align-items-center justify-content-between"
                    class:selected="{ listIndex === index }"
                    on:click={ () => onSelect(item) }>
                    <div>{ item.type }</div>
                    <div class="text-gray-1">{ item.total }</div>
                </li>
            {/each}
        </div>
    {/if}
</div>
